// @import_dependencies
// @end

// @import services
// @end

// @import utilities
// @end

// @import types
// @end

class ReactSelectService {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {}

  public formatReactSelectResponse = (response: any) => {
    if (Array.isArray(response)) {
      // @INFO: Cuando es multiple
      let values: Array<any> = []
      response.map((r) => values.push(r.value))
      return values
    } else {
      // @INFO: Cuando es simple
      return (response.value) ? response.value : null
    }
  }

}

export default ReactSelectService
